/* eslint-disable no-console */
import { register } from 'register-service-worker'
import cacheManager from '@/utils/cacheManager'

const force = !!process.env.VUE_APP_FORCE_SERVICE_WORKER || true;
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

if (isProduction || force) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('🚀 App sendo servido pelo service worker');
      
      if (isProduction) {
        cacheManager.startPerformanceMonitoring();
        setTimeout(() => {
          cacheManager.preloadCriticalResources().catch(console.warn);
        }, 1000);
      }
    },

    registered(registration) {
      console.log('✅ Service worker registrado');
      
      if (isProduction) {
        // Verifica atualizações a cada hora
        setInterval(() => {
          registration.update().catch(console.warn);
        }, 60 * 60 * 1000);

        // Verificação inicial após 5s
        setTimeout(() => {
          registration.update().catch(console.warn);
        }, 5000);
      }
    },
    cached() {
      console.log('💾 Conteúdo em cache para uso offline');
      
      if (isProduction) {
        setTimeout(async () => {
          try {
            const report = await cacheManager.generateCacheReport();
            console.log('📊 Cache inicial:', report.totalItems, 'itens');
          } catch (error) {
            console.warn('Erro ao gerar relatório:', error);
          }
        }, 2000);
      }
    },
    updatefound() {
      console.log('⬇️ Nova versão sendo baixada');
      window.dispatchEvent(new CustomEvent("swUpdateFound", { detail: { status: 'downloading' } }));
    },
    updated(registration) {
      console.log('🆕 Nova versão disponível');

      if (registration && registration.waiting) {
        window.dispatchEvent(new CustomEvent("swUpdated", { detail: registration.waiting }));
        window.dispatchEvent(new CustomEvent("newVersionAvailable", {
          detail: { registration, waiting: registration.waiting, timestamp: Date.now() }
        }));

        registration.waiting.postMessage({ type: "NEW_VERSION_READY" });
      }
    },
    offline() {
      console.log('📱 Modo offline ativo');
      window.dispatchEvent(new CustomEvent("appOffline", { 
        detail: { offline: true, timestamp: Date.now() }
      }));
    },
    error(error) {
      console.error('❌ Erro no service worker:', error);
      window.dispatchEvent(new CustomEvent("swRegistrationError", {
        detail: { error: error.message || 'Falha no registro', timestamp: Date.now() }
      }));
    }
  });

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (isProduction) {
        cacheManager.optimizeCache().catch(console.warn);
      }
    });

    navigator.serviceWorker.addEventListener('message', (event) => {
      const { data } = event;
      if (data.type === 'NEW_VERSION_AVAILABLE') {
        console.log(`🆕 Nova versão ${data.version?.substring(0, 8)} disponível`);
      }
    });

    // Sincronização quando volta online (apenas em produção)
    if (isProduction) {
      window.addEventListener('online', () => {
        console.log('🌐 Online - sincronizando');
        cacheManager.syncCache().catch(console.warn);
      });

      window.addEventListener('offline', () => {
        console.log('📱 Offline - usando cache');
      });
    }
  }
} else {
  console.log('🚫 Service Worker desabilitado');
}

// Utilitários
export const serviceWorkerUtils = {
  isSupported: () => 'serviceWorker' in navigator,
  isRegistered: () => 'serviceWorker' in navigator && navigator.serviceWorker.controller,
  
  async getRegistration() {
    if (!('serviceWorker' in navigator)) return null;
    return await navigator.serviceWorker.getRegistration();
  },
  
  async forceUpdate() {
    const registration = await this.getRegistration();
    if (registration) {
      await registration.update();
      return true;
    }
    return false;
  }
};

if (isDevelopment) {
  window.swUtils = serviceWorkerUtils;
  window.cacheManager = cacheManager;
}
